import { connectHits } from "react-instantsearch-dom";
import FaqFeaturedArticle from "app/pages/Faq/FaqHome/FaqFeaturedArticles/FaqFeaturedArticle";
import PropTypes from "prop-types";
import "./FaqFeaturedArticles.scss";
import { FormattedMessage } from "react-intl";

const FaqFeaturedArticles = ({ hits }) => {
	return (
		hits.length > 0 && (
			<div className="faq-home__featured-articles">
				<div className="faq-featured-articles">
					<div className="faq-featured-articles__title">
						<FormattedMessage id="faq.home.feature.article.title" />
					</div>

					<div className="faq-featured-articles__list">
						{hits.map((hit = {}) => {
							const articleLink = `/faq/category/${hit.categoryID}/subcategory/${
								hit.subCategoryID
							}/article/${hit.articleID}`;

							return (
								<div key={hit.objectID} className="faq-featured-articles__item">
									<FaqFeaturedArticle
										articleName={hit.title}
										articleContent={hit.content}
										breadcrumb={hit["categories.lvl1"]}
										articleLink={articleLink}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		)
	);
};

FaqFeaturedArticles.propTypes = {
	hits: PropTypes.array,
};

FaqFeaturedArticles.defaultProps = {
	hits: [],
};

export default connectHits(FaqFeaturedArticles);
